import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { IStartMenu } from "../../../models/localization";
import { ScreenMode } from "../../../models/enums";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./tagline.css";

@inject("store") @observer
export class Tagline extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const local: IStartMenu = this.props.store.localization.fields.startMenu;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    if (!local.startTagline) { return null; }
    return (<Col xs={12} className={s.taglineCol} >
      {mode === ScreenMode.Mobile && <h6 className={s.tagline}>{local.startTagline}</h6>}
      {mode === ScreenMode.Tablet && <h4 className={s.tagline}>{local.startTagline}</h4>}
      {mode === ScreenMode.Desktop && <h3 className={s.tagline}>{local.startTagline}</h3>}     
    </Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/start/tagline/index.tsx